var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2764,
    cy: 40.2764,
    rx: 40.2764,
    ry: 40.2764,
    fill: "#A1A1A1",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2161 41.3538L28.5549 59.7017L29.4957 21.3762L62.2161 41.3538Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayGrey);
export default __webpack_public_path__ + "static/media/PlayGrey.358b9a29bccc751f1024b6d05c089364.svg";
export { ForwardRef as ReactComponent };